import React from 'react';
import { styled } from '@mui/system';
import ListItemIcon from '@mui/material/ListItemIcon/index';
import Typography from '@mui/material/Typography';
import eventIcon from '#component/icon/event';

const WarningIcon = styled(ListItemIcon)(() => ({
  minWidth: '32px !important'
}));

const WarningsLabelContainer = styled('div')(() => ({
  display: 'flex',
  margin: '0 5px 0 -5px',
  whiteSpace: 'nowrap',
  flexGrow: 0,
  '& p:nth-of-type(2)': {
    marginLeft: '-5px',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
}));

export const WarningLabel = props => {
  const { warnings } = props;
  const warningsMessage = `${warnings.length} ${warnings.length === 1 ? 'warning' : 'warnings'}`;
  const allAccepted = warnings?.every(w => w?.details?.acceptance);
  const withWarning = warnings?.find(w => !w?.details?.acceptance);

  return (
    <WarningsLabelContainer>
      <WarningIcon>
        {eventIcon(allAccepted ? warnings[0] : withWarning)}
      </WarningIcon>
      <Typography>{warningsMessage}</Typography>
    </WarningsLabelContainer>
  );
};
